import Blank from './Blank'

export default {
  id: 'Blank',
  svg: Blank,
  positioning: {
    pointNarrow: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
    pointMedium: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
    pointWide: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
    roundNarrow: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
    roundMedium: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
    roundWide: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
    squareNarrow: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
    squareMedium: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
    squareWide: {
      x: 0,
      y: 0,
      scaleX: 0,
    },
  },
}
